import client from './client';
import { getUserId, getAuthCode } from './authStorage';

/** Approve a sponsored post */
export async function approveSponsorship(sponsored_post_id) {
  const user_id = getUserId();
  const auth_code = getAuthCode();

  const payload = {
    user_id,
    auth_code,
    sponsored_post_id,
    decision: 'approve'
  };

  const { data: res } = await client.post('/admin/approve_sponsor.php', payload);

  if (res.status !== 200) {
    throw new Error(res.message || 'Failed to approve sponsorship');
  }
  return res;
}

/** Reject a sponsored post */
export async function rejectSponsorship(sponsored_post_id, reason) {
  const user_id = getUserId();
  const auth_code = getAuthCode();

  const payload = {
    user_id,
    auth_code,
    sponsored_post_id,
    decision: 'reject',
    reason
  };

  const { data: res } = await client.post('/admin/approve_sponsor.php', payload);

  if (res.status !== 200) {
    throw new Error(res.message || 'Failed to reject sponsorship');
  }
  return res;
}